import { SpotCrowdedLabel } from '@/components/molecules/spots/SpotCrowdedLabel'
// import { degreeDistanceTimes100k } from '@/lib/calcGeoLocationDistance'
import { CircleLoading } from '@/components/ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface SpotDetailProps {
  /** スポット名 */
  name: string | string[]
  /** 音声ガイドの有無 */
  audioGuide: { caption: string; audio: string }[]
  audioGuideLoading: boolean
  /** 音声ガイドの有効範囲 */
  audioGuideRange: number
  onAudioGuideClick: () => void
  hasSheets: boolean
  sheetNames: string | string[]
  /**
   * false:全てのスタンプが期間外の場合
   * true:1つでも期間内のスタンプがある
   * */
  inPeriod?: boolean
  /**
   * スタンプorポイントを獲得しているかのフラグ
   * - 獲得可能なスタンプがあれば：未獲得
   * - それ以外は、「獲得可能：期間外であっても獲得済みのスタンプが有る」・「未獲得：期間外でも、獲得済みのスタンプが無い」の状態に準じる
   * */
  isHas?: boolean
  spotLocation: {
    latitude: number
    longitude: number
  }
  /** ユーザーの現在地。今は音声ガイドの有効範囲を動的に変更するために使っている */
  userLocation?: {
    latitude: number
    longitude: number
  }
  address?: string
  url?: string
  isCoupons: boolean
  description: string
  spotCrowded?: Api.SpotCrowded
}

export const SpotDetail = ({
  name,
  audioGuide,
  // audioGuideRange,
  audioGuideLoading,
  onAudioGuideClick,
  spotLocation,
  // userLocation,
  address,
  url,
  isCoupons,
  description,
  hasSheets,
  sheetNames,
  inPeriod,
  isHas,
  spotCrowded,
}: SpotDetailProps) => {
  const { t } = useTranslation()
  // const distance = degreeDistanceTimes100k(spotLocation, userLocation ?? { latitude: 0, longitude: 0 })
  // 音声ガイドが存在し、音声ガイドのレンジが0より大きい場合に、enable & disableを決定するフラグ
  // const isAudioGuideAvailable = audioGuideRange > 0 ? distance <= audioGuideRange : true
  return (
    <>
      <h1 className="text-tsm font-bold">{name}</h1>

      <div className="relative mt-3">
        <div className={'flex justify-between w-full'}>
          <div className={'flex flex-col justify-end'}>
            {hasSheets && (
              <p className="text-xs text-color01">
                {isHas ? t('spot_detail.acquired', '獲得済み') : t('spot_detail.un_acquired', '未獲得')}
              </p>
            )}
            {/*{!inPeriod && <p className="text-xs text-color01">{t('spot_detail.--', '期間外')}</p>}*/}
          </div>
          <div>
            {spotCrowded && <SpotCrowdedLabel spotCrowded={spotCrowded} />}
            {audioGuide?.length > 0 && (
              <button
                type="button"
                className="w-20 py-1 px-0 border border-black rounded flex flex-col justify-center items-center"
                onClick={onAudioGuideClick}
              >
                {audioGuideLoading ? (
                  <div className={'h-[32px] flex items-center justify-center'}>
                    <CircleLoading size={'medium'} color={'main'} />
                  </div>
                ) : (
                  <>
                    <img
                      src={`${process.env.NEXT_PUBLIC_SITEURL}/images/common/icon/volume-high-solid.svg`}
                      alt="音声ガイド"
                      className="w-[15px] h-[15px] object-contain"
                    />
                    <p className="text-[10px] font-semibold whitespace-nowrap scale-90 mt-[2px]">
                      {t('spot_detail.audio_guide', '音声ガイド')}
                    </p>
                  </>
                )}
              </button>
            )}
          </div>
        </div>

        <p className={'mt-2 text-xs underline'}>
          <a
            className="text-linkcolor"
            href={`https://www.google.com/maps/search/?api=1&map_action=map&query=${spotLocation.latitude},${spotLocation.longitude}`}
            rel="noopener noreferrer"
          >
            {address}
          </a>
        </p>
        {url && (
          <p className="c-blank mt-2 text-xs underline">
            <a className="text-linkcolor" href={url} target="_blank" rel="noopener noreferrer">
              {url}
            </a>
            <img className="c-blank_icon" src={`${process.env.NEXT_PUBLIC_SITEURL}/images/icon_blank.svg`} alt="" />
          </p>
        )}
        {/* スポットコース名が入る */}
        {hasSheets && (
          <>
            {Array.isArray(sheetNames) ? (
              [...new Set(sheetNames)].map((v, i) => (
                <p className="c-tag mt-3 mr-2 inline-block text-xss text-sub" key={`${v}`}>
                  {v}
                </p>
              ))
            ) : (
              <p className="c-tag mt-3 mr-2 inline-block text-xss text-sub">{sheetNames}</p>
            )}
          </>
        )}

        {isCoupons && (
          <p className="c-tag c-tag--coupon mt-3 mr-2 inline-block text-xss">{t('spot_detail.coupon', 'クーポン')}</p>
        )}
        <p
          className="wysiwyg mt-6 text-[16px] leading-6"
          // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
          dangerouslySetInnerHTML={{
            __html: `${description}`,
          }}
        />
      </div>
    </>
  )
}
